<template>
    <el-form label-width="80px" :model="formData" ref="formData" :rules="formDataRules" style="margin:50px auto 0;width: 500px;">
        <el-form-item label="房间号" prop="houseid" style="position:reletive;">
            <!-- <cmp-build-select :disabled="disabled" :buildRoom="buildRoom" selectType="householdid" @listenBuildResult="listenBuildResult"></cmp-build-select> -->
            <cmp-build-selectbind :disabled="disabled"   :buildRoom="buildRoom" selectType="householdid" @listenBuildResult="listenBuildResult"></cmp-build-selectbind>
			<!-- <cmp-build-selectbind :buildRoom="buildRoom" selectType="householdid" @listenBuildResult="listenBuildResult"></cmp-build-selectbind> -->
            <span v-if="formData.houseid" class="btn-meterInfobox"><el-button type="text" icon="el-icon-caret-bottom" @click="handleShowMeter">{{showMeter? "收起": "展开"}}</el-button></span>
        </el-form-item>
        <div :class="showMeter ? 'meterInfo-box sildeUp': 'meterInfo-box sildeDown'">
            <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    prop="terminal_serial"
                    label="表计型号">
                </el-table-column>
                <el-table-column
                    prop="online_status"
                    label="表计状态">
                    <template slot-scope="scope">
                        {{scope.row.online_status === 1 ? '在线': '离线'}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="HouseHoldValue"
                    label="表计读数">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.HouseHoldValue" placeholder="请输入表计读数"></el-input>
                    </template>  
                </el-table-column>
            </el-table>
            <div style="text-align:center;margin-top:5px;margin-right:10px;">
                <el-button class="fr" type="primary" @click="handleSaveMeter" size="mini">确认修改</el-button>
            </div>
        </div>
        <el-form-item label="业主名称" prop="name">
            <el-input v-model="formData.name" placeholder="请输入业主名称"></el-input>
        </el-form-item>
        <el-form-item prop="password">
            <template slot="label">
                <span>密码
                    <el-tooltip class="item" effect="dark" content="默认密码123456" placement="top-start">
                        <i class="el-icon-info" style="vertical-align: top;font-size: 12px;"></i>
                    </el-tooltip>
                </span>
            </template>
            <el-input type="password" v-model="formData.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="IDCard">
            <el-select v-model="formData.IDCard" placeholder="请选择证件类型">
                <el-option
                    v-for="v in cardTypeList"
                    :key="v.value"
                    :label="v.label"
                    :value="v.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="IDNum">
            <el-input v-model="formData.IDNum" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex" v-if="formData.IDCard != 3 ">
            <el-radio-group v-model="formData.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号码" prop="telephone">
            <el-input v-model="formData.telephone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="formData.email" placeholder="请输入电子邮箱"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="handleSubmit">确认并添加</el-button>
        </el-form-item>

    </el-form>
</template>

<script>
import CmpBuildSelectbind from '@/components/CmpBuildSelect/CmpBuildSelectbind'
//import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'
import Service from '@/api/Service'
import { IDCARD } from '@/api/configData'
import stringUtils from '@/utils/stringUtils'

import { checkPhone, checkEmail } from '@/utils/validator'

export default {
    name: "CmpLesseeForm",
    props: ["itemData"],
    inject: ["reload"],
    components: {
        CmpBuildSelectbind
    },
    data() {
        // 验证身份证号码
        const checkIDnum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入证件号码"));
            } else {
                if(this.formData.IDCard === 1){
					// console.log('good')
                    if (stringUtils(value).isIDcard()) {
                        callback();
                    } else {
                        return callback(new Error("身份证格式有误"));
                    }
                }if(this.formData.IDCard === 2){
					// console.log('goodjob')
					if (stringUtils(value).isPassport()) {
					    callback();
					} else {
					    return callback(new Error("护照格式有误"));
					}
				}else{
                    callback();
                }
            }
        };
        // const checkIDnum = (rule, value, callback) => {
        //     if (!value) {
        //         return callback(new Error("请输入证件号码"));
        //     } else {
        //             if (stringUtils(value).isIDcard()) {
        //                 callback();
        //             } else {
        //                 return callback(new Error("身份证格式有误"));
        //         }
        //     }
        // };
        const checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("电话号码不能为空"));
            } else {
                if (stringUtils(value).isMobilePhone() || stringUtils(value).isTelPhone()) {
                    callback();
                } else {
                     return callback(new Error("电话号码格式有误"));
                }
            }
        };
        return {
            // 表单数据
            formData: {
                houseid: '',    //  房间ID
                name: '',
                sex: 1,
                IDCard: 1,
                IDNum: '',
                telephone: '',
                password: '123456',
                email: '',
            },
            // 表单验证规则
            formDataRules: {
                name: [{ required: true, trigger: "blur", message: "请输入名称" }],
                password: [{ required: true, trigger: "blur", message: "请输入密码" }],
                IDNum: [{ required: true, trigger: "blur",validator: checkIDnum}],
                telephone: [{ required: true, validator: checkPhone, trigger: "blur", }],
                email: [{ required: true, validator: checkEmail, trigger: "blur", }],
            },
            // 增加类型
            cardTypeList: IDCARD,

            // 选择房间组件
            buildRoom: {},

            tableData: [],
            showMeter: false,

        };
    },
    created() {
        this.initData();
    },
    watch: {
        itemData() {
            this.initData();
        }
    },
    
    methods: {
        // 格式化初始数据
        initData() {
            this.disabled = JSON.stringify(this.itemData) != '{}'
			//判断该业主是不是处于销户状态下 已开户修改 房间信息不允许修改
			if(this.itemData.household_status == 2 || this.itemData.household_status == 1){
				this.disabled = true
			}else{this.disabled = false}
			
            // if(!this.disabled) return
			//判断有没有证件类型
			if(this.itemData.id_card == 0){
				this.itemData.IDCard = ''
			}
			// console.log(this.itemData)
            let {oid, name, sex, id_card, id_num, telephone, password, email, houseName, choseHouseList } = this.itemData;
           
            this.formData.name = name;
            this.formData.sex = sex;
            this.formData.IDCard = id_card;
            this.formData.IDNum = id_num;
            this.formData.telephone = telephone;
            this.formData.password = password;
            this.formData.email = email;
            this.buildRoom.houseName = houseName;
            this.buildRoom.choseHouseList = choseHouseList;

            this.getMeterInfo(oid)
            
        },
        // 添加业主
        handleSubmit() {
            this.$refs.formData.validate(async valid => {
                if (valid) {
                    if(JSON.stringify(this.itemData) == '{}'){
                        if(!this.formData.houseidlist) {
                            this.$notify({
                                title: '提示',
                                message: '请选择要绑定房间号！',
                                type: 'warning'
                            });
                            return
                        }
                        // 添加业主
                        let data = await Service.addMultiLessee(this.formData);
                        if(data) {
                            this.$message({
                                type: 'success',
                                message: '操作成功!',
                                duration: 1500,
                                onClose: ()=>{
                                    this.$router.push("/household");
                                }
                            });
                        }
                    }else {
                        // 修改业主
                        let obj = Object.assign(this.formData, {oid: this.itemData.oid})
                        let data = await Service.editMultiLessee(obj);
                        if(data) {
                            this.reload();
                        }
                    }
                }
            });
        },
        // 确认房间ID
        listenBuildResult(data) {
            if(data.length>0) {
                let a = []
                data.map(v=>{
                    a.push({oid: v.oid + ""})
                })
                this.formData.houseidlist = a
            }
            
            // if(data.OID) {
            //     this.getMeterInfo(data.OID)
                
            // }
        },
        // 获取房间内表计信息
        async getMeterInfo(oid) {
            // let data = await Service.getTerminalvalue({assigned_house_id: oid});
            // if(data) {
            //     this.showMeter = (data !== 'success');
            //     data = data === 'success' ? [] : data;
            //     this.tableData = data;
            // }
        },
        // 展开表计
        handleShowMeter() {
            this.showMeter = !this.showMeter;
        },
        // 修改表计
        async handleSaveMeter() {
            let householdvaluelist = this.tableData.map(v=>{
                return {
                    oid: v.OID + "",
                    household_value: v.HouseHoldValue
                }
            })
            
            let res = await Service.editTerminalvalue({householdvaluelist})
            if(res) {
                this.showMeter = false;
                this.$message({
                    type: 'success',
                    message: '操作成功!',
                });
            }
        }
    }
};
</script>

<style scoped lang="less">
.add-household-form {
    width: 500px;
    /* padding: 24px 0; */
    margin: auto;
    /* margin-top: -30px; */
}
.step-box {
    padding: 24px 200px;
}
.title {
    padding: 4px;
    margin-bottom: 24px;
    font-size: 18px;
    border-bottom: 1px solid #dcdfe6;
}
.tab-list {
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 24px;
}
.tab-list .tab-item {
    display: inline-block;
    padding: 0 20px;
    height: 40px;
    box-sizing: border-box;
    line-height: 40px;
    list-style: none;
    font-size: 14px;
    font-weight: 500;
    color: #909399;
    position: relative;
    cursor: pointer;
}
.tab-list .tab-item.active {
    color: @primary-color;
    border-bottom: 2px solid @primary-color;
}
.meterInfo-box{
    padding: 15px 15px 5px 15px;
    margin-bottom: 5px;
    overflow: hidden;
    background-color: #fafafa;
    transition: height .5s ease-in;
    -moz-transition: height .5s ease-in; /* Firefox 4 */
    -webkit-transition: height .5s ease-in; /* Safari 和 Chrome */
    -o-transition: height .5s ease-in; /* Opera */
    &.sildeUp{
        height: auto;
    }
    &.sildeDown{
        height: 0;
        padding: 0;
    }
}
.btn-meterInfobox{
    position: absolute;
    z-index: 99;
    right: -60px;
    top: 0;
    cursor: pointer;
}
</style>
